import { render } from "./Coupon250B.vue?vue&type=template&id=461501ac&scoped=true"
import script from "./Coupon250B.vue?vue&type=script&lang=js"
export * from "./Coupon250B.vue?vue&type=script&lang=js"

import "./Coupon250B.vue?vue&type=style&index=0&id=461501ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-461501ac"

export default script